module.exports = __webpack_public_path__ + "media/images/spinner-c7b3cbb3.gif";